import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';

interface AppThemeProps {
  children: React.ReactNode;
  disableCustomTheme?: boolean;
  themeComponents?: ThemeOptions['components'];
}

export default function AppTheme(props: AppThemeProps) {
  const { children, disableCustomTheme, themeComponents } = props;
  const theme = React.useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme({
          cssVariables: {
            colorSchemeSelector: 'data-mui-color-scheme',
            cssVarPrefix: 'template',
          },
          typography: {
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          },
          colorSchemes: {
            light: {
              palette: {
                // Brand colors
                primary:   { main: '#00A676' },
                secondary: { main: '#0F1720' },
                background: { default: '#F7FBF9', paper: '#ffffff' },
              },
            },
            dark: {
              palette: {
                primary:   { main: '#00A676' },
                secondary: { main: '#81C784' },
                background: { default: '#121212', paper: '#1e1e1e' },
              },
            },
          },
          components: {
            ...themeComponents,
            MuiListItemButton: {
              styleOverrides: {
                root: {
                  borderRadius: '8px',
                  color: '#0F1720',
                  transition: 'none',
                  '& .MuiListItemIcon-root': { color: '#0F1720', transition: 'none' },
                  '&.Mui-selected': {
                    backgroundColor: '#00A676',
                    color: '#ffffff',
                    '& .MuiListItemIcon-root': { color: '#ffffff' },
                    '&:hover': { backgroundColor: '#009068' },
                  },
                  '&:hover': { backgroundColor: 'rgba(0,166,118,0.08)' },
                },
              },
            },
          },
        });
  }, [disableCustomTheme, themeComponents]);
  if (disableCustomTheme) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
